import React from 'react';

import BaseIcon, { type BaseIconProps } from '../BaseIcon';

const CheckIcon: React.FC<BaseIconProps> = ({ ...rest }) => {
  return (
    <BaseIcon {...rest} viewBox="0 0 12 12" fill="none">
      <path
        d="M10 3L4.5 8.5L2 6"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  );
};

export default CheckIcon;
